import { FeeNature } from "../enums/FeeNature";
import { flowDigests } from "./flowDigests";

export const useDummyDigestSummary = false;

export const flowDigestSummary = {
    ...flowDigests[0],
    items: 2, // MAKE SURE BACKEND RETURNS THIS TOO
    // comment ID: https://bukku.atlassian.net/browse/ENG-3488?focusedCommentId=19919
    fee_types: [{
        id: 1,
        name: 'Sales',
        description: null,
        nature: FeeNature.INCOME,
        amount: 150,
    },
    {
        id: 2,
        name: 'Discount',
        description: null,
        nature: FeeNature.INCOME,
        amount: 11,
    },
    {
        id: 3,
        name: 'Shipping',
        description: null,
        nature: FeeNature.EXPENSE,
        amount: -22,
    },
    {
        id: 4,
        name: 'Service Fee',
        description: null,
        nature: FeeNature.EXPENSE,
        amount: -1.32,
    },
    ],
    payment_methods: [{
        id: 1,
        name: 'Credit Card',
        description: null,
        amount: 22,
    },
    {
        id: 2,
        name: 'Debit Card',
        description: null,
        amount: 109,
    },
    {
        id: 3,
        name: 'Cash',
        description: null,
        amount: 21.3,
    },
    ],
};
